<template>
  <div v-loading="isLoading">
    <div v-if="list && list.length > 0" class="my-table">
      <div
        class="table-item"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetail(item)"
      >
        <div class="img">
          <img :src="item.ImgPath" alt="" @error="imgError" />
        </div>
        <div class="flex1">
          <div class="content mt10">
            {{ item.CourseName }}
          </div>
          <div class="flex">
            <div class="rate">
              <span class="mr5">{{ item.StarNum }}</span>
              <el-rate
                v-model="item.StarNum"
                disabled
                text-color="#ff9900"
                class="mt1"
              >
              </el-rate>
            </div>
            <div class="user mr10">
              <img src="@/assets/img/home/4.png" alt="" />{{ item.StudyView }}
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        class="center mt30 mb70"
        @current-change="(page) => getList(page)"
        background
        :page-size="18"
        hide-on-single-page
        layout="prev, pager, next"
        :total="count"
      >
      </el-pagination>
    </div>
    <el-empty v-if="list.length == 0" description="暂无资料" :image="empty1" />
  </div>
</template>
<script>
import { Teacher_GetCourses } from "@/api/teacher";
export default {
  name: "TeacherCourse",
  data() {
    return { isLoading: false, PageIndex: 1, list: [], count: 0 };
  },
  props: {
    id: [String, Number],
  },
  watch: {
    id: {
      deep: true,
      handler(v) {
        this.getList(1);
        // this.list = v.map(item => ({ ...item, Ext: item.Ext.replace('.', ''), downLoading: false }))
      },
    },
  },
  components: {},
  created() {
    this.getList(1);
  },
  methods: {
    getList(page) {
      this.isLoading = true;
      Teacher_GetCourses({
        TeacherID: this.id,
        PageSize: 18,
        PageIndex: page,
      })
        .then((res) => {
          this.isLoading = false;
          this.list = res.data;
          this.count = res.count || this.list.length;
        })
        .catch(() => {});
    },
    toDetail(item) {
      this.$router.push({
        path: "/courseDetail",
        query: { CourseID: item.CourseID },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.my-table {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  .table-item {
    cursor: pointer;
    width: 437px;
    height: 127px;
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #e9ecf0;
    padding: 10px;
    display: flex;
    gap: 20px;
    &:hover {
      transform: scale(1.01);
    }
    .content {
      font-size: 20px;
      color: #333333;
      display: -webkit-box;
      overflow: hidden; /* 超出的文本隐藏 */
      text-overflow: ellipsis; /* 溢出用省略号显示 */
      -webkit-box-orient: vertical; /* 垂直排列子元素 */
      -webkit-line-clamp: 2; /* 显示的行数 */
    }
    .img {
      width: 140px;
      height: 104px;
      border-radius: 6px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .type {
        font-size: 16px;
        color: #999999;
      }
      .amout {
        font-size: 24px;
        font-weight: bold;
      }
      .red {
        font-size: 16px;
        color: #e12a14;
    font-weight: bold;

      }
      .user {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #666666;
        img {
          width: 12px;
          height: 17px;
          margin-right: 9px;
        }
      }
      .rate {
        display: flex;
        font-weight: bold;
        font-size: 20px;
        color: #e12a14;
      }
    }
  }
}
</style>
